import {marketingAssets} from '../../content/marketingAssets.js';

import type {ReactElement} from 'react';

const catalogImage = new URL('../../assets/sneaker-catalog.png', import.meta.url).href;

export const SeedanceBenefits = (): ReactElement => (
  <section aria-labelledby="seedance-benefits-heading" className="seedance-benefits overflow-hidden rounded-[2rem] border border-violet-300/20 bg-[#181322]">
    <div className="grid items-stretch md:grid-cols-[1fr_2fr_1.2fr]">
      <div className="relative min-h-56 bg-white">
        <img alt="Original white and purple sneaker on a plain white background" className="h-full max-h-72 w-full object-contain md:absolute md:inset-0 md:max-h-none" loading="lazy" src={catalogImage} />
        <span className="absolute top-4 left-4 rounded-full bg-black/5 px-3 py-1.5 text-[10px] tracking-[.12em] text-zinc-600 uppercase">Your product</span>
      </div>
      <div className="flex items-center gap-4 px-5 py-7 sm:gap-6 sm:px-7 md:py-9">
        <span aria-hidden="true" className="shrink-0 text-4xl font-light text-violet-300">+</span>
        <div className="min-w-0 flex-1">
          <p className="text-[10px] font-semibold tracking-[.18em] text-sky-200 uppercase">Just add imagination</p>
          <h3 className="mt-3 text-2xl leading-tight tracking-tight sm:text-3xl" id="seedance-benefits-heading">Your product.<br /><span className="text-violet-300">A whole new scene.</span></h3>
          <blockquote className="mt-4 text-sm leading-6 text-white/75">“Suspend the sneaker in a burst of water. Dark background. Dramatic lighting.”</blockquote>
        </div>
        <span aria-hidden="true" className="shrink-0 text-4xl font-light text-violet-300">=</span>
      </div>
      <div className="relative min-h-64 overflow-hidden">
        <img alt="Campaign concept: the same sneaker suspended in a dramatic splash of water" className="h-full w-full object-cover md:absolute md:inset-0" loading="lazy" src={marketingAssets.campaign} />
        <span className="absolute top-4 right-4 rounded-full border border-white/20 bg-black/45 px-3 py-1.5 text-[10px] tracking-[.12em] text-white/80 uppercase">Your campaign</span>
      </div>
    </div>
  </section>
);
